import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

let _cache = null;
let _pending = null;
const _subs = new Set();

const loadOnce = () => {
  if (_cache) return Promise.resolve(_cache);
  if (_pending) return _pending;
  _pending = axios
    .get(`${API}/scenes`)
    .then((res) => {
      _cache = res.data.scenes || {};
      _pending = null;
      for (const fn of _subs) fn(_cache);
      return _cache;
    })
    .catch((err) => {
      _pending = null;
      throw err;
    });
  return _pending;
};

export function useScenes() {
  const [scenes, setScenes] = useState(_cache || {});

  useEffect(() => {
    let active = true;
    const sub = (s) => {
      if (active) queueMicrotask(() => setScenes(s));
    };
    _subs.add(sub);
    if (!_cache) {
      loadOnce().catch(() => {
        if (active) queueMicrotask(() => setScenes({}));
      });
    } else {
      queueMicrotask(() => setScenes(_cache));
    }
    return () => {
      active = false;
      _subs.delete(sub);
    };
  }, []);

  return scenes;
}

export function useScene(id) {
  const scenes = useScenes();
  return scenes?.[id] || null;
}
